import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Close from './assets/Close.png';
import LinkIco from './assets/link.png';
// Social media
import smFB from './assets/sm_fb.png';
import smMessenger from './assets/sm_messenger.png';
import smLine from './assets/sm_line.png';

import { disableEnableScroll } from '@tw/style-guide/lib/components/utilities/util';
import styles from './share.scss';
import Drawer from '../Drawer/Drawer';
import { toastMsg } from '../toastMessage/toastMessage';
import Breakpoint from '@tw/style-guide/lib/components/utilities/breakpoint';
import axios from "../../utils/axios_interceptor"
import { getAcApiUrl, getLoggedInUserInfo } from '../../utils/helper';
import { getADA, getAccessHeader } from '../../utils/loginSession';
import { getIMCID } from '../../utils/analytics'
import { getCSFrontendMsg } from '../../utils/utility';
import { frontEndMessageCodes } from '../../utils/Constants/Constants';
import { trackSharedCopyLink, trackSharedViaMessenger, trackSharedViaFacebook, trackSharedViaLine } from "../../utils/analytics";

const Share = props => {
  const { showPopup, title, url, shareInfo, is3e, callBack, enabled, successShareCallBack, product, search_keyword } = props;
  const [breakpoint, setBreakpoint] = useState('xs');
  const [encodedTxt, setEncodedTxt] = useState('');
  const { loginAda } = getLoggedInUserInfo();
  let isDesktop = breakpoint !== 'xs' && breakpoint !== 'sm';
  const appId = '458571282274466';
  let toURL = url;

  if (typeof window !== 'undefined') {
    if (shareInfo && shareInfo.type) {
      toURL = location.origin + '/' + shareInfo.type + '/' + shareInfo.id;
    }
  }

  toURL += `?d=${encodedTxt}&utm_medium=sharebar&utm_campaign=zh_tw_${getIMCID(loginAda)}`;

  if (is3e) toURL += '&3e=1';

  useEffect(() => {
    if (showPopup) disableEnableScroll(true);

    getEncryptedId();

    return () => {
      disableEnableScroll(false);
    };
  }, [showPopup]);

  const getEncryptedId = () => {
    axios
      .post(
        getAcApiUrl() + '/share/encode',
        {
          text: getADA(),
        },
        {
          headers: getAccessHeader(),
        }
      )
      .then(res => {
        setEncodedTxt(res.data.encrypted);
      });
  };
  const onBackdropClick = () => {
    callBack();
  };

  const onSuccessShare = () => {
    successShareCallBack();
  };

  const handleClickInside = e => {
    e.stopPropagation();
  };


  const isIOS = () =>
    /iPad|iPhone|iPod/.test(navigator.platform) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

  const shareLine = e => {
    trackSharedViaLine(product, search_keyword) // utag  数据上报
    const linkUrl = `${toURL}&utm_source=line`
    if (isDesktop) {
      let shareURL = 'https://social-plugins.line.me/lineit/share?url=';
      shareURL += encodeURI(linkUrl);
      window.open(shareURL, '_blank');
      onSuccessShare();
    } else {
      let shareURL = '';
      if (isIOS()) {
        shareURL = 'line://msg/text/';
        shareURL += encodeURI(linkUrl);
      } else {
        shareURL = 'https://social-plugins.line.me/lineit/share?url=';
        shareURL += encodeURI(linkUrl);
      }
      window.open(shareURL, '_blank');
      onSuccessShare();
    }
  };

  const shareFB = e => {
    const linkUrl = `${toURL}&utm_source=facebook`
    trackSharedViaFacebook(product, search_keyword) // utag  数据上报
    let shareURL = 'https://www.facebook.com/sharer/sharer.php?u=';
    shareURL += encodeURI(linkUrl);
    window.open(shareURL, '_blank');
    onSuccessShare();
  };

  const shareMsg = e => {
    const linkUrl = `${toURL}&utm_source=messenger`
    trackSharedViaMessenger(product, search_keyword) // utag  数据上报
    if (isDesktop) {
      let shareURL = 'https://www.facebook.com/dialog/send?app_id=' + appId + '&link=';
      shareURL += encodeURI(linkUrl);
      shareURL += '&redirect_uri=' + encodeURI(linkUrl);
      window.open(shareURL, '_blank');
    } else {
      let shareURL = '';
      if (isIOS()) {
        shareURL = 'fb-messenger://share/?link=';
        shareURL += encodeURI(linkUrl);
        shareURL += '&app_id=' + appId;
      } else {
        shareURL = 'https://www.facebook.com/dialog/send?app_id=' + appId + '&link=';
        shareURL += encodeURI(linkUrl);
        shareURL += '&redirect_uri=' + encodeURI(linkUrl);
      }
      window.open(shareURL, '_blank');
      onSuccessShare();
    }
  };

  const copyLink = async (e, opt) => {
    let successMsg = await getCSFrontendMsg(frontEndMessageCodes.SHAREBAR_SUCCESS_COPY);
    const linkUrl = `${toURL}&utm_source=copylink`
    if (typeof window !== 'undefined') {
      setTimeout(async () => await navigator.clipboard.writeText(linkUrl).then(function () {
        if (opt) {
          toastMsg('您已成功複製鏈接，請粘貼到' + opt + '上');

        }
        else {
          toastMsg(successMsg.message, '', successMsg.messageType);
        }
        trackSharedCopyLink(product, search_keyword) // utag  数据上报
        onSuccessShare();
      }, function () {
        console.log("Copy to clipboard unsuccessfully.");
      })
      );
    }
  };

  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={showPopup}
      ModalProps={{ onBackdropClick: () => onBackdropClick() }}
    >
      {encodedTxt !== '' && (
        <div className={styles.share_container} onClick={onBackdropClick}>
          <div className={`${styles.body_container}`} onClick={handleClickInside}>
            <div className={styles.close_bar}>
              <button
                tabIndex="0"
                aria-label="Close"
                type="button"
                className={styles.close_button}
                onClick={onBackdropClick}
              >
                <img src={Close} />
              </button>
              <button className={styles.close_notch} onClick={onBackdropClick}></button>
            </div>

            <div className={``}>
              {enabled ? (
                <div className={styles.title}>{title}</div>
              ) : (
                <div className={styles.title}>功能未開放</div>
              )}
              {!enabled ? (
                <div className={`${styles.content}`}>
                  <p style={{ marginLeft: isDesktop ? 34 : 27 }}>暫時不能夠分享商品</p>
                </div>
              ) : (
                <div className={`${styles.content}`}>
                  <div onClick={shareLine}>
                    <span className={styles.smIco}>
                      <img src={smLine} />
                    </span>
                    <span className={styles.smText}>Line</span>
                  </div>

                  {/* <div onClick={shareInsta}>
                    <span className={styles.smIco}><img src={smInsta} /></span>
                    <span className={styles.smText}>Instagram</span>
                  </div> */}

                  <div onClick={shareMsg}>
                    <span className={styles.smIco}>
                      <img src={smMessenger} />
                    </span>
                    <span className={styles.smText}>Messenger</span>
                  </div>

                  <div onClick={shareFB}>
                    <span className={styles.smIco}>
                      <img src={smFB} />
                    </span>
                    <span className={styles.smText}>Facebook</span>
                  </div>
                </div>
              )}
            </div>
            {enabled ? (
              <div className={`${styles.link}`} onClick={copyLink}>
                <span>複製連結</span>
                <span className={styles.img}>
                  <img src={LinkIco} />
                </span>
              </div>
            ) : null}
          </div>
        </div>
      )}
      <Breakpoint onBreakpointChange={setBreakpoint} />
    </Drawer>
  );
};

Share.defaultProps = {
  title: 'Share',
  url: '',
  shareInfo: {
    type: '', // product/category/promotions/bundle
    id: '',
  },
  is3e: false,
  callBack: () => {
    console.log('Call back');
  },
  showPopup: false,
  tncMsg1: '我同意遵守安麗公司社群商務經營規範。',
  tncMsg2: '恭喜您已開通！',
};

Share.propTypes = {
  title: PropTypes.string,
  url: PropTypes.string,
  shareInfo: PropTypes.object,
  is3e: PropTypes.bool,
  callBack: PropTypes.func,
  successShareCallBack: PropTypes.func,
  showPopup: PropTypes.bool,
  tncMsg1: PropTypes.string,
  tncMsg2: PropTypes.string,
};

export default Share;
